import { useForm } from 'react-hook-form';

import { SelectedItemsFromLocalStorage } from '@/components/contextMenu/mwdContextMenu/types';
import { VerzwakInzettenOpdracht } from '@/queries/mutaties/opdrachten';
import { useMutaties } from '@/queries/mutaties/useMutaties';

export const useMultiVerzwakkenDialog = (
  details: SelectedItemsFromLocalStorage[],
  handleOpenChange: (open: boolean) => void,
) => {
  const { verzwakInzetten } = useMutaties();
  const { handleSubmit, clearErrors } = useForm({
    mode: 'onSubmit',
  });

  // reset all values
  const resetDialog = (closeButtonCLick: boolean) => {
    if (closeButtonCLick) {
      handleOpenChange(false);
    }
  };

  const onSubmit = async () => {
    const verzwakMeerdereInzettenOpdracht: VerzwakInzettenOpdracht = {
      betrokkenWerklijn: {
        id: details[0].werklijnId,
        versie: details[0].versieId,
      },
      teVerzwakkenInzetten: details.map((d) => d.selectedId),
    };
    await (async () => {
      const result = await verzwakInzetten(verzwakMeerdereInzettenOpdracht);
      if (result.status === 'SUCCES') resetDialog(true);
    })();
  };

  return {
    handleSubmit,
    clearErrors,
    onSubmit,
    resetDialog,
  };
};
